import { defineRecipe as i } from "@pandacss/dev";
const r = i({
  className: "spinner",
  base: {
    display: "inline-block",
    borderWidth: "3px",
    borderStyle: "solid",
    borderRadius: "full",
    width: "var(--size)",
    height: "var(--size)",
    animation: "spin 1s linear infinite"
  },
  defaultVariants: {
    size: "md",
    color: "dark"
  },
  variants: {
    size: {
      sm: { "--size": "16px" },
      md: { "--size": "20px" },
      lg: { "--size": "24px" }
    },
    color: {
      light: { borderColor: "fg-white" },
      dark: { borderColor: "fg-primary" }
    }
  }
});
export {
  r as spinner
};
